import { request } from '../utils/request';

const skiData = {
  getContinents: async () => {
    return request({
      url: '/continents'
    });
  },

  getCountries: async (continent) => {
    return request({
      url: `/countries/${encodeURIComponent(continent)}`
    });
  },

  getRegions: async (country) => {
    return request({
      url: `/regions/${encodeURIComponent(country)}`
    });
  },

  getFilteredAndRankedResorts: async (filters, weights, offset = 0, limit = 100) => {
    const requestBody = {
      filters,
      weights,
      offset,
      limit
    };

    console.log('Request body:', requestBody);

    return request({
      url: '/resorts',
      method: 'POST',
      data: requestBody
    });
  },

  getResortDetail: async (resortId) => {
    try {
      console.log('Fetching resort details for ID:', resortId);
      
      // 并行请求基本数据、评论和标签
      const [basicResponse, reviewsResponse, tagsResponse] = await Promise.all([
        request({
          url: `/resort/${resortId}?source=web`,
          method: 'GET'
        }),
        request({
          url: `/reviews/${resortId}?source=web`,
          method: 'GET'
        }),
        request({
          url: `/tags?source=web&resortId=${resortId}&limit=999&includeRanking=true&levelOrder=world,continent,country,region`,
          method: 'GET'
        })
      ]);

      // 合并数据
      return {
        ...basicResponse,
        reviews: reviewsResponse?.reviews || [],
        tags: tagsResponse?.tags || [],
        totalTags: tagsResponse?.total || 0
      };
    } catch (error) {
      console.error('Failed to fetch resort detail:', error);
      throw error;
    }
  },

  getResortTags: async (resortId) => {
    try {
      console.log('Fetching tags for resort:', resortId);
      return request({
        url: `/tags?source=web&resortId=${resortId}&limit=999&includeRanking=true&levelOrder=world,continent,country,region`,
        method: 'GET'
      });
    } catch (error) {
      console.error('Failed to fetch resort tags:', error);
      throw error;
    }
  },

  getWeatherMap: async ({ startDate, endDate, indexType, north, south, east, west }) => {
    try {
      const url = `/resorts/weather?source=web&startDate=${startDate}&endDate=${endDate}&indexType=${indexType}&north=${north}&south=${south}&east=${east}&west=${west}`;

      return request({
        url: url,
        method: 'GET'
      });
    } catch (error) {
      console.error('Failed to fetch weather map:', error);
      throw error;
    }
  }
};

export default skiData; 